export default __webpack_public_path__ + "static/media/t4.c03a4ecd.jpg";